export default {
  dashboard: 'Dashboard',
  orders: 'Pesanan',
  masterData: 'Master Data',
  customer: 'Customer',
  transporter: 'Rekanan 3PL',
  vehicleTypes: 'Tipe Kendaraan',
  logout: 'Logout'
}
